import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import { productionTechnology } from '../../constants/parameters';

export default createValidation([
  {
    name: productionTechnology.CODE,
    validators: [(field) => validatorRequired()(field)],
  },
  {
    name: `${productionTechnology.LANG}.${productionTechnology.ESTONIAN}`,
    validators: [(field) => validatorRequired()(field)],
  },
  {
    name: `${productionTechnology.LANG}.${productionTechnology.ENGLISH}`,
    validators: [(field) => validatorRequired()(field)],
  },
]);
